module.exports = __webpack_public_path__ + "img/UncheckWhite.4bbcc3c7.svg";